// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"363":"6b898ccf8966fa6e6def","537":"8533e613be326831f3c9","934":"6ffcb3728d3ee94964a9"}[chunkId] + ".css";
};